import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class CommissionLineSearchParams extends SearchParamsBase {
  static saveType = 'CommissionLineSearchParams';
  initialize() {
    this.SelectedUserIds = [];
    this.SelectedExternalSalesPartnerId = null;
    this.ClientIds = [];
    this.OpportunityIds = [];
    this.ServiceIds = [];
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    {
      fieldName: 'SelectedUserIds',
      label: 'User',
      className: 'col-6',
      type: InputTypesEnum.CommissionUserMultiChoice,
    },
    {
      fieldName: 'SelectedExternalSalesPartnerId',
      label: 'External Sales Partner',
      className: 'col-6',
      type: InputTypesEnum.ExternalSalesPartnerSelect,
    },
    {
      fieldName: 'ClientIds',
      label: 'Client',
      className: 'col-6',
      type: InputTypesEnum.ClientMultiChoice,
    },
    {
      fieldName: 'OpportunityIds',
      label: 'Opportunity',
      className: 'col-6',
      type: InputTypesEnum.OpportunityMultiChoice,
      idFilter: (item) => item.ClientIds,
      disabled: (item) => !item.ClientIds || item.ClientIds.length === 0,
    },
    {
      fieldName: 'ServiceIds',
      label: 'Service',
      className: 'col-6',
      type: InputTypesEnum.ServiceMultiChoice,
      idFilter: (item) => item.OpportunityIds,
      disabled: (item) => !item.OpportunityIds || item.OpportunityIds.length === 0,
    },
  ];
}
